import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { forwardRef, useImperativeHandle, useState } from 'react';

export type DescriptionCellProps = {
  label: string;
  description?: string;
  isReadOnly: boolean;
}

export type DescriptionCellHandle = {
  getValue: () => string | undefined;
  reset: (value: string) => void;
}

const DescriptionCell = forwardRef<DescriptionCellHandle, Readonly<DescriptionCellProps>>(
  function DescriptionCell(props, forwardedRef) {
    const [localDescription, setLocalDescription] = useState<string | undefined>(props.description);

    useImperativeHandle(forwardedRef, () => ({
      getValue: () => localDescription,
      reset: (value: string) => setLocalDescription(value),
    }));

    if (props.isReadOnly) {
      return (
        <Typography variant="body1">
          {localDescription}
        </Typography>
      );
    }

    return (
      <TextField
        variant="standard"
        fullWidth
        label={props.label}
        value={localDescription}
        onChange={(e) => setLocalDescription(e.currentTarget.value)}
      />
    )
  });

export default React.memo(DescriptionCell);
